import { ValidateUspsAddressState } from './validateUspsAddress.types'

const initialState: ValidateUspsAddressState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
